import { createSelector } from '@reduxjs/toolkit';
import { EditIcon } from 'evergreen-ui';
import { dcpcApi } from './dcpcApi';
import { getToasterError } from '../utils';

const MICROSERVICES_TAG = 'Microservices';

dcpcApi.enhanceEndpoints({ addTagTypes: [MICROSERVICES_TAG] });
const microservicesApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getMicroservices: builder.query({
      query: () => 'microservices',
      providesTags: [MICROSERVICES_TAG],
      // todo: убрать тостер, когда будет middleware на обработку ошибок
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          getToasterError(err, 'микросервисов', 'microservices');
        }
      },
    }),
    getMicroservice: builder.query({
      query: (id) => `microservices/${id}`,
      providesTags: [MICROSERVICES_TAG],
      // todo: убрать тостер, когда будет middleware на обработку ошибок
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          getToasterError(err, 'микросервиса', 'microservice');
        }
      },
    }),
    updateMicroservice: builder.mutation({
      query: ({ id, body }) => ({
        url: `microservices/${id || ''}`,
        method: id ? 'PUT' : 'POST',
        body,
      }),
      invalidatesTags: [MICROSERVICES_TAG],
    }),

    getDVValidator: builder.query({
      query: (param) => ({
        url: `module/dv-validator/${param}`,
        method: 'GET',
      }),
      providesTags: [MICROSERVICES_TAG],
      extraOptions: {
        noToaster: true,
      },
    }),
    getModuleCalc: builder.query({
      query: (param) => ({
        url: `module/calc/${param}`,
        method: 'GET',
      }),
      providesTags: [MICROSERVICES_TAG],
      extraOptions: {
        noToaster: true,
      },
    }),
    getModuleTelegram: builder.query({
      query: (param) => ({
        url: `module/telegram/${param}`,
        method: 'GET',
      }),
      providesTags: [MICROSERVICES_TAG],
      extraOptions: {
        noToaster: true,
      },
    }),
    clearAllCaches: builder.query({
      query: () => 'evictAllCaches',
    }),
  }),
});

export const {
  useGetMicroservicesQuery,
  useGetMicroserviceQuery,
  useUpdateMicroserviceMutation,

  useGetDVValidatorQuery,
  useGetModuleCalcQuery,
  useGetModuleTelegramQuery,
  useLazyClearAllCachesQuery,
} = microservicesApi;

export const microservicesSelect = (state) => microservicesApi.endpoints.getMicroservices.select()(state);
export const microservicesSelector = (state) => microservicesSelect(state).data || [];

const filterMicroservicesBySearchTextSelector = createSelector(
  microservicesSelector,
  (_, searchText) => searchText,
  (microservices, searchText) => ({
    columns: [
      {
        label: 'Наименование',
      },
      {
        label: 'Описание',
      },
      {
        label: 'URL',
      },

    ],
    rows: microservices.reduce((acc, cur) => {
      const {
        id, name, description, microserviceUrl,
      } = cur;
      const row = [id, name, description, microserviceUrl];
      if (row.filter((v, idx) => (idx !== 0 && v !== null && v.toString().toUpperCase().includes(searchText.toUpperCase()))).length > 0) {
        acc.push(row);
      }
      return acc;
    }, []),
    rowButtons: [
      {
        label: 'Редактировать',
        to: (id) => `${id}`,
        icon: EditIcon,
      },
    ],
    createLink: {
      label: 'Создать микросервис',
    },
  }),
);

export const microservicesBySearchTextSelector = (searchText) => (state) => filterMicroservicesBySearchTextSelector(state, searchText);
